<template>
  <div class="progress-wrap">
    <div
      class="progress"
      :style="progressStyle"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    progress: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    progressStyle() {
      return { width: `${this.progress}%` };
    },
  },
});
</script>

<style lang="scss" scoped>
.progress-wrap {
  width: 100%;
  @include responsiveStyleSingle(height, 0.2667, 'vw');
  background-color: rgba(255, 255, 255, 0.1);
  .progress {
    @include responsiveStyleSingle(height, 0.2667, 'vw');
    background-color: rgba(255, 255, 255, 0.5);
    transition: width 0.1s linear;
  }
}
</style>
